import { FC } from 'react';
import { useRedirectOnAuth } from '../../aws/AuthHooks';
import { AuthState } from '../../aws/AuthProvider';
import { ROUTE } from '../routes';
import Users from '../../components/users/Users';
import { useTranslation } from 'react-i18next';

const Doctors: FC = () => {
  const { t } = useTranslation();
  useRedirectOnAuth([AuthState.UNAUTHORIZED], ROUTE.LOGIN);
  return <Users title={t('Doctors')} mode={'doctor'} />;
};

export default Doctors;
